import { CdkStep } from "@angular/cdk/stepper";
import {
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
} from "@angular/core";

@Component({
  selector: "quicksign-step",
  templateUrl: "./quicksign-step.component.html",
  styleUrls: ["./quicksign-step.component.css"],
  providers: [{ provide: CdkStep, useExisting: QuicksignStepComponent }],
})
export class QuicksignStepComponent extends CdkStep {
  _childrenHidden = false;
  @Input() disabled = false;
  @Input() hidden = false;
  @Input() interactedOverride: boolean | null = null;
  @Input() isAdder = false;
  @Input() isButton = false;
  @Input() isHeader = false;
  @Input() isParent = false;
  @Input() isSubstep = false;
  @Input() nextButtonText = "NEXT";
  @Input() previousButtonText = "BACK";
  @Input() tooltip = "";
  @Output() buttonClick = new EventEmitter();
  @Output() next = new EventEmitter();
  @Output() previous = new EventEmitter();

  @ContentChildren(QuicksignStepComponent, { descendants: true })
  children: QueryList<QuicksignStepComponent>;

  get isNormalStep() {
    return (
      !this.isHeader && !this.isButton && !this.isParent && !this.isSubstep
    );
  }

  get isStep() {
    return !this.isHeader && !this.isButton && !this.isParent;
  }

  ngOnInit() {
    if (this.isHeader || this.isButton || this.isAdder) {
      this.completed = true;
    }
    if (this.interactedOverride !== null) {
      this.interacted = this.interactedOverride;
    }
  }

  toggleShowChildren() {
    this._childrenHidden = !this._childrenHidden;
    this.children.forEach((child) => {
      child.hidden = this._childrenHidden;
    });
  }
}
